import React from 'react';
import { Modal } from 'react-bootstrap';
import Button from '../command/Button/Button';
import { useTranslation } from 'react-i18next';
import './productDetails.scss';

interface OwnitInfoModalProps {
  show: boolean;
  onHide: () => void;
}

const OwnitInfoModal: React.FC<OwnitInfoModalProps> = ({ show, onHide }) => {
  const { t } = useTranslation();
  
  return (
    <Modal
      show={show}
      onHide={onHide}
      centered
      className="calendar-modal ownit-info-modal"
      aria-labelledby="ownit-info-modal"
    >
      <Modal.Header closeButton>
        <div className='w-100'><h4 className='ownit-popup-title mt-3 text-center'> {t('Try it, love it.')} <span className='ownit-text-blackgreen'>OWN<span>it.</span></span></h4>
        <p className='text-center'>{t('Try-before-you-buy.')}</p></div>
      </Modal.Header>
      <Modal.Body>
        <div className="ownit-modal-content">


     <div className="row justify-content-center ownit-steps g-3">
  <div className="col-4 col-md-4">
    <div className="card text-center ownit-step-card h-100">
      <div className="ownit-step-icon mb-2">
        {/* QR code icon */}
        
<svg width="48" height="54" viewBox="0 0 48 54" fill="none" xmlns="http://www.w3.org/2000/svg" xmlnsXlink="http://www.w3.org/1999/xlink">
<g filter="url(#filter0_d_606_2212)">
<path d="M39.9592 4H8.04083C5.80914 4 4 5.79243 4 8.00351V45.1965C4 47.4076 5.80914 49.2 8.04083 49.2H39.9592C42.1909 49.2 44 47.4076 44 45.1965V8.00351C44 5.79243 42.1909 4 39.9592 4Z" fill="white"/>
</g>
<mask id="mask0_606_2212" mask-type="alpha" maskUnits="userSpaceOnUse" x="6" y="7" width="36" height="36">
<rect x="6.60034" y="7.37683" width="35" height="35" fill="#D9D9D9"/>
</mask>
<g mask="url(#mask0_606_2212)">
<rect x="1.8277" y="2.1167" width="44.7443" height="45.5202" fill="url(#pattern0_606_2212)"/>
</g>
<defs>
<filter id="filter0_d_606_2212" x="0" y="0" width="48" height="53.2" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB">
<feFlood flood-opacity="0" result="BackgroundImageFix"/>
<feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha"/>
<feOffset/>
<feGaussianBlur stdDeviation="2"/>
<feComposite in2="hardAlpha" operator="out"/>
<feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"/>
<feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_606_2212"/>
<feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_606_2212" result="shape"/>
</filter>
<pattern id="pattern0_606_2212" patternContentUnits="objectBoundingBox" width="1" height="1">
<use xlinkHref="#image0_606_2212" transform="matrix(0.00339114 0 0 0.00333333 -0.00867052 0)"/>
</pattern>
<image id="image0_606_2212" width="300" height="300" preserveAspectRatio="none"   xlinkHref="data:image/png;base64,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"/>
</defs>
</svg>

      </div>
      <div className="ownit-step-text">
        {t('Rent the item and try it.')}
      </div>
    </div>
  </div>
  <div className="col-4 col-md-4 ">
    <div className="card text-center ownit-step-card h-100">
      <div className="ownit-step-icon mb-2">
        {/* Bag icon */}
        <svg width="36" height="36" viewBox="0 0 36 36" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M9 3L4.5 9V30C4.5 30.7956 4.81607 31.5587 5.37868 32.1213C5.94129 32.6839 6.70435 33 7.5 33H28.5C29.2956 33 30.0587 32.6839 30.6213 32.1213C31.1839 31.5587 31.5 30.7956 31.5 30V9L27 3H9Z" stroke="#00989E" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
<path d="M4.5 9H31.5" stroke="#00989E" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
<path d="M24 15C24 16.5913 23.3679 18.1174 22.2426 19.2426C21.1174 20.3679 19.5913 21 18 21C16.4087 21 14.8826 20.3679 13.7574 19.2426C12.6321 18.1174 12 16.5913 12 15" stroke="#00989E" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
</svg>
      </div>
      <div className="ownit-step-text">
        {t('Get the option to buy with a discount.')}
      </div>
    </div>
  </div>
  <div className="col-4 col-md-4 ">
    <div className="card text-center ownit-step-card h-100">
      <div className="ownit-step-icon mb-2">
        {/* Heart icon */}
        <svg width="36" height="36" viewBox="0 0 36 36" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M31.26 6.91499C30.4939 6.1485 29.5842 5.54046 28.583 5.12562C27.5818 4.71077 26.5087 4.49725 25.425 4.49725C24.3413 4.49725 23.2682 4.71077 22.267 5.12562C21.2658 5.54046 20.3561 6.1485 19.59 6.91499L18 8.50499L16.41 6.91499C14.8625 5.36745 12.7635 4.49806 10.575 4.49806C8.38645 4.49806 6.28753 5.36745 4.74 6.91499C3.19246 8.46253 2.32306 10.5614 2.32306 12.75C2.32306 14.9385 3.19246 17.0375 4.74 18.585L6.32999 20.175L18 31.845L29.67 20.175L31.26 18.585C32.0265 17.8189 32.6345 16.9092 33.0494 15.908C33.4642 14.9068 33.6777 13.8337 33.6777 12.75C33.6777 11.6663 33.4642 10.5931 33.0494 9.59196C32.6345 8.59077 32.0265 7.68113 31.26 6.91499Z" stroke="#00989E" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
</svg>
      </div>
      <div className="ownit-step-text">
        {t('Buy & Keep or return.')}
      </div>
    </div>
  </div>
</div>

        <div className="ownit-gradient-banner p-3 mb-3 rounded">
  <span>
    Select your rental dates<br />
    and get your optional <b className='ownit-text-black'>OWN<span>it.</span></b> Price.
  </span>
</div>
          
      
<div className="mb-3">
  <h6 className="fw-semibold mb-3">
    Learn more about <span className="ownit-text">OWN<span >it.</span></span>
  </h6>
  <ul className="list-unstyled ownit-list mb-3">
    <li>
      <span className="ownit-bullet me-2"></span>
      Pay a fixed price to rent and try the item
    </li>
    <li>
      <span className="ownit-bullet me-2"></span>
      Love it? Purchase it at a discounted price
    </li>
    <li>
      <span className="ownit-bullet me-2"></span>
      Keep what you love, return what you don’t.
    </li>
  </ul>
  <div className="alert alert-warning ownit-alert mb-0 py-2 px-3" role="alert">
    There is no contractual obligation to buy, any purchase will form a separate transaction. 
    Terms and conditions apply.
  </div>
</div>
        </div>
      </Modal.Body>
    
    </Modal>
  );
};

export default OwnitInfoModal;
